import * as m from "mithril";
import TripResultCard from "./TripResultCard";
import { MessageProvider } from '../../context/AppMessages';
import './TripResultList.scss';
import { Dialog } from '../../components/MaterialDesignComponents';
import Stars from '../../components/Stars';
import { OperatorRatingSummaryDTO, TripDTO } from "../../apiclient/ApiDtos";
import SearchCriteria from "../../models/SearchCriteria";

interface Attrs {
    searchCriteria: SearchCriteria,
    tripResults: TripDTO[],
    messageProvider: MessageProvider,
    onViewSeatButtonClick: (res) => void
    onViewOperatorPhotosButtonClick:(result)=>void
}

function TripResultList(): m.Component<Attrs> {
    let currentRatingSummary:OperatorRatingSummaryDTO|null = null;

    return {     
        view(vnode) {
            return [
                    m("div", { class: 'pr-0 pl-0 pb-2 pt-0 mb-2' },[
                        (currentRatingSummary)?
                        m(Dialog, {
                            title: "Rating Summary",
                            isOpen: currentRatingSummary != null,
                            onClose : () => {
                                currentRatingSummary = null;
                            },                            
                            actionItems : [
                                {
                                    label: "Ok",
                                    onclick: () => {
                                        currentRatingSummary = null;
                                    }
                                }                            
                            ]
                        }, [
                            m("table.table table-stripped", [
                                m("tr", [
                                    m("td", vnode.attrs.messageProvider.get("feedback_driver_discipline")), 
                                    m("td", m(Stars, {value: currentRatingSummary.driverBehavior}))
                                ]),
                                m("tr", [
                                    m("td", vnode.attrs.messageProvider.get("feedback_driver_comfort")), 
                                    m("td", m(Stars, {value: currentRatingSummary.seatComfortableness}))
                                ]),
                                m("tr", [
                                    m("td", vnode.attrs.messageProvider.get("feedback_driver_cleanliness")), 
                                    m("td", m(Stars, {value: currentRatingSummary.cleanliness}))
                                ]),
                                m("tr", [
                                    m("td", vnode.attrs.messageProvider.get("feedback_driver_service")), 
                                    m("td", m(Stars, {value: currentRatingSummary.staffHelpfulness}))
                                ]),
                                m("tr", [
                                    m("td", vnode.attrs.messageProvider.get("feedback_driver_punctuality")), 
                                    m("td", m(Stars, {value: currentRatingSummary.punctuality}))
                                ]),
                            ])
                        ]) :null,

                        (vnode.attrs.tripResults.length == 0)?
                        m("div",{class:"pt-5 px-3"},[
                            m("h5",{class:"text-center font-weight-bold"}, vnode.attrs.messageProvider.get("message.no_express_trip_available")),
                            m("div", {class:"text-center text-muted font-italic_ mb-4"}, vnode.attrs.messageProvider.get("message.change_date_or_route"))                        
                        ])
                        :null,
                        
                        vnode.attrs.tripResults.map(function (tripResult) {
                            return m("div.mb-2", 
                                m(TripResultCard, {
                                    numberOfSeats: vnode.attrs.searchCriteria.numberOfSeats,
                                    tripResult: tripResult,
                                    messageProvider: vnode.attrs.messageProvider,
                                    onViewOperatorPhotosButtonClick: function (result) {
                                        vnode.attrs.onViewOperatorPhotosButtonClick(result)
                                    },
                                    onViewSeatButtonClick: (result) => {
                                        vnode.attrs.onViewSeatButtonClick(result);
                                    },
                                    onRatingSummaryClick: (ratingSummary) => {
                                        currentRatingSummary = ratingSummary;
                                    }
                                })                            
                            );
                        
                        })
                    ]),  
            ];
        }
    }
};

export default TripResultList;